/* eslint-disable  max-lines */
import gsap from 'gsap/all'

export default class Menu {
  constructor() {
    this.menuOpen = false
    this.isAnimating = false
    this.el = document.querySelector('.header')

    this.bindMethods()
    this.getElems()
    this.addEvents()
    this.init()
    this.initTl()
  }

  bindMethods() {
    this.toggle = this.toggle.bind(this)

    this.closeMegaMenu = this.closeMegaMenu.bind(this)
    this.openMegaMenu = this.openMegaMenu.bind(this)
    this.openSearch = this.openSearch.bind(this)
    this.closeSearch = this.closeSearch.bind(this)
    this.openSubMenu = this.openSubMenu.bind(this)
    this.closeSubMenu = this.closeSubMenu.bind(this)
  }

  getElems() {
    this.$mainMenu = this.el.querySelector('.header-main__content-w')
    this.$menuItems = this.el.querySelectorAll('.header-main__mainItem')
    this.$parentItems = this.el.querySelectorAll('.header-main__mainItem--parent')
    this.$subMenus = this.el.querySelectorAll('.header-sub__wrapper')
    this.$subItems = this.el.querySelectorAll('.header-sub__subitem')
    this.$subMenuClose = this.el.querySelectorAll('.header-sub__close')
    this.subMenus = []
    this.toggler = this.el.querySelector('.burger-menu')

    this.$searchButtons = this.el.querySelectorAll('.header-main__search-button')
    this.$searchForm = this.el.querySelector('.c-search__form')
    this.$searchQuicklinks = this.el.querySelector('.c-search__quickLinks')

    this.$megaMenu = this.el.querySelector('.c-mega-menu')
    this.$megaMenuButton = this.el.querySelector('.header-main__mainItem--catalog')
    this.$megaMenuItem = this.el.querySelectorAll('.c-mega-menu__child')
    this.$megaMenuClose = this.el.querySelector('.c-mega-menu__close')

    for (let i = 0; i < this.$parentItems.length; i++) {
      const button = this.$parentItems[i]
      const menu = this.$subMenus[i]
      const close = this.$subMenuClose[i]

      this.subMenus.push({
        button,
        menu,
        isOpen: false,
        close
      })
    }
  }

  init() {
    this.canCloseSubmenu = true;
    this.sizeItems()
    this.currentItem = null
    this.currentSubItem = null
    this.currentSubMenu = null

    this.megaMenuOpen = false
    this.searchOpen = false
  }

  sizeItems() {
    if (window.innerWidth < 1024) {
      gsap.set(this.$mainMenu, {
        xPercent: 100
      })
      gsap.set(this.$megaMenu, {
        xPercent: 100,
        yPercent: 0
      })
    } else {
      gsap.set(this.$mainMenu, {
        xPercent: 0
      })
      gsap.set(this.$megaMenu, {
        xPercent: 0,
        yPercent: -100
      })
    }

    this.subMenus.forEach((el) => {
      if (window.innerWidth >= 1024) {
        gsap.set(el.menu, {
          xPercent: 0,
          yPercent: -105
        })
      } else {
        gsap.set(el.menu, {
          xPercent: 105,
          yPercent: 0
        })
      }
    })

    gsap.set(this.$searchForm, {
      yPercent: -100
    })
    gsap.set(this.$searchQuicklinks, {
      yPercent: 100
    })
  }

  initTl() {
    this.openMegaMenuTl = (callback) => {
      const tl = gsap.timeline({
        onComplete: () => {
          callback()
        }
      })

      if (window.innerWidth <= 1024) {
        tl.to(this.$megaMenu, {
          xPercent: 0,
          duration: 1.2,
          ease: 'power4.out'
        })
      } else {
        tl.to(this.$megaMenu, {
          yPercent: 0,
          duration: 1.2,
          ease: 'power4.out'
        })
      }

      return tl
    }

    this.closeMegaMenuTl = (callback) => {
      const tl = gsap.timeline({
        onComplete: () => {
          callback()
        }
      })

      if (window.innerWidth <= 1024) {
        tl.to(this.$megaMenu, {
          xPercent: 100
        })
      } else {
        tl.to(this.$megaMenu, {
          yPercent: -100
        })
      }

      return tl
    }

    this.openSearchTl = (callback) => {
      const tl = gsap.timeline({
        onComplete: () => {
          callback()
        }
      })

      tl.to(this.$searchForm, {
        yPercent: 0
      })
      tl.to(this.$searchQuicklinks, {
        yPercent: 0
      }, 0)

      return tl
    }

    this.closeSearchTl = (callback) => {
      const tl = gsap.timeline({
        onComplete: () => {
          callback()
        }
      })

      tl.to(this.$searchForm, {
        yPercent: -100
      }, 0)
      tl.to(this.$searchQuicklinks, {
        yPercent: 100
      }, 0)

      return tl
    }

    this.openMenuTl = (callback) => {
      const tl = gsap.timeline({
        onComplete: () => {
         callback()
        }
      })

      tl.to(this.$mainMenu, {
        xPercent: 0
      })

      return tl
    }

    this.closeMenuTl = (callback) => {
      const tl = gsap.timeline({
        onComplete: () => {
         callback()
        }
      })

      tl.to(this.$mainMenu, {
        xPercent: 100
      })

      return tl
    }

    this.openSubMenuTl = (element, callback) => {
      const tl = gsap.timeline({
        onComplete: () => {
          callback()
        }
      })

      if (window.innerWidth >= 1024) {
        tl.to(element.menu, {
          yPercent: 0
        })
      } else {
        tl.to(element.menu, {
          xPercent: 0
        })
      }

      return tl
    }

    this.closeSubMenuTl = (element, callback) => {
      const tl = gsap.timeline({
        onComplete: () => {
          callback()
        }
      })

      if (window.innerWidth >= 1024) {
        tl.to(element.menu, {
          yPercent: -105
        })
      } else {
        tl.to(element.menu, {
          xPercent: 100
        })
      }

      return tl
    }
  }

  addEvents() {
    this.toggler && this.toggler.addEventListener('click', this.toggle)

    for (let i = 0; i < this.$menuItems.length; i++) {
      const element = this.$menuItems[i];

      if (element.href === location.href) element.classList.add('active')

      element.addEventListener('click', () => {
        this.currentItem = element
      })
    }

    for (let i = 0; i < this.subMenus.length; i++) {
      const element = this.subMenus[i];

      element.button.addEventListener('mouseenter', () => {
        this.openSubMenu(element);
      })

      element.button.addEventListener('click', () => {
        this.openSubMenu(element);
      })

      element.button.addEventListener('mouseleave', () => {
        this.closeSubMenu(element)
      })

      element.menu.addEventListener('mouseenter', () => {
        this.openSubMenu(element);
      })

      element.menu.addEventListener('mouseleave', () => {
        if (this.canCloseSubmenu === true) this.closeSubMenu(element)
      })

      element.close.addEventListener('click', () => {
        this.closeSubMenu(element)
      })
    }

    for (let i = 0; i < this.$subItems.length; i++) {
      const element = this.$subItems[i];

      element.addEventListener('click', () => {
        this.currentSubItem = element
      })
    }

    for (let i = 0; i < this.$searchButtons.length; i++) {
      const element = this.$searchButtons[i];

      element.addEventListener('click', () => {
        this.toggleSearch()
      })
    }

    for (let i = 0; i < this.$megaMenuItem.length; i++) {
      const element = this.$megaMenuItem[i];

      element.addEventListener('click', () => {
        this.currentMegaItem = element
      })
    }
    this.$megaMenuButton.addEventListener('click', () => {
      this.toggleMegaMenu()
    })
    this.$megaMenuClose.addEventListener('click', () => {
      this.closeMegaMenu()
    })
  }

  toggleSearch() {
    this.searchOpen ? this.closeSearch() : this.openSearch()
  }

  toggleSubMenu(element) {
    this.currentSubMenu ? this.closeSubMenu(element) : this.openSubMenu(element)
  }

  toggleMegaMenu(element) {
    this.megaMenuOpen ? this.closeMegaMenu(element) : this.openMegaMenu(element)
  }

  openMegaMenu() {
    return new Promise((resolve) => {
      this.$megaMenuButton.classList.add('open')
      this.openMegaMenuTl(resolve)
      if (this.searchOpen) this.closeSearch()
      this.megaMenuOpen = true
    })
  }

  closeMegaMenu() {
    return new Promise((resolve) => {
      this.$megaMenuButton.classList.contains('open') && this.$megaMenuButton.classList.remove('open')
      this.closeMegaMenuTl(resolve)
      this.megaMenuOpen = false
    })
  }

  openSearch() {
    return new Promise((resolve) => {
      this.openSearchTl(resolve)
      if (this.megaMenuOpen) this.closeMegaMenu()
      if (this.menuOpen) this.close()
      for (let i = 0; i < this.$searchButtons.length; i++) {
        const element = this.$searchButtons[i];

        element.querySelector('.header-main__search-icon').classList.add('hide')
        element.querySelector('.header-main__search-close').classList.remove('hide')
      }
      this.searchOpen = true
    })
  }

  closeSearch() {
    return new Promise((resolve) => {
      this.closeSearchTl(resolve)
      for (let i = 0; i < this.$searchButtons.length; i++) {
        const element = this.$searchButtons[i];

        element.querySelector('.header-main__search-icon').classList.remove('hide')
        element.querySelector('.header-main__search-close').classList.add('hide')
      }
      this.searchOpen = false
    })
  }

  openSubMenu(element) {
    return new Promise((resolve) => {
      this.openSubMenuTl(element, resolve)
      this.currentItem = element
      this.currentSubMenu = element
      element.isOpen = true
    })
  }

  closeSubMenu(element) {
    return new Promise((resolve) => {
      this.closeSubMenuTl(element, resolve)
      element.isOpen = false
    })
  }

  /**
  * Toggle Menu to open or close it
  * @returns {any} null
  */
  toggle() {
    if (this.isAnimating) return

    if (this.menuOpen) this.close()
    else this.open()
  }

  /**
  * Open Menu
  * @returns {Promise} return Promise when open animation end
  */
  open() {
    return new Promise((resolve) => {
      this.toggler.classList.add('open')
      this.menuOpen = true
      this.openMenuTl(resolve)
      if (this.searchOpen) this.closeSearch()
    })
  }

  /**
  * Close Menu
  * @returns {Promise} return Promise when close animation end
  */
  close() {
    return new Promise((resolve) => {
      this.toggler.classList.contains('open') && this.toggler.classList.remove('open')
      this.menuOpen = false
      this.closeMenuTl(resolve)
      if (this.currentSubMenu) this.closeSubMenu(this.currentSubMenu)
    })
  }

  resize() {
    const closePromises = [];

    if (this.megaMenuOpen) closePromises.push(this.closeMegaMenu())
    if (this.searchOpen) closePromises.push(this.closeSearch())
    for (let i = 0; i < this.subMenus.length; i++) {
      const element = this.subMenus[i];

      closePromises.push(this.closeSubMenu(element))
    }

    Promise.all(closePromises).then(() => {
      this.sizeItems()
    })
  }

  scroll() {}

}



// WEBPACK FOOTER //
// ./scripts/util/Menu.js